import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { MenuItem } from 'primeng/api';
import { Route, Router } from '@angular/router';
import { CatalogService } from 'app/modules/catalog-cloud/services/catalog.service';
import { Catalog } from '@nousmedis/cc-types';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent implements OnInit {

    @ViewChild('menubutton') menuButton!: ElementRef;
    menuOpened: boolean = false;
    showIt: boolean = false;
    items: MenuItem[] = []; // This is the menu items for the topbar (Temporary)
    catalog: Catalog;

    constructor (public layoutService: LayoutService,
        private route: Router,
        private catalogService: CatalogService

    ) {
        this.menuOpened = this.layoutService.state.staticMenuDesktopInactive;
    }


    ngOnInit(): void {
        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.

        this.searchChanges();
    }

    setMenuItems() {
        this.items = [
            {
                label: 'CatalogCloud',
                command: () => { this.route.navigate(['/dash']); },
                icon: 'pi pi-fw pi-home'
            }, {
                label: 'Catálogo',
                icon: 'pi pi-fw pi-th-large',
                items: [
                    {
                        label: this.catalog.name,
                    },
                    {
                        label: 'Fascículos',
                        items: this.catalog ? this.catalog.fascicles.map(fascicle => {
                            return {
                                label: fascicle.name,
                                command: () => { this.route.navigate(['catalog/' + this.catalog.id + '/fascicle/' + fascicle.id]); }
                            };
                        }) : []
                    }]
            },
            {
                label: 'Configuración',
                icon: 'pi pi-fw pi-cog',
                items: [
                    {
                        label: 'Nueva Plantilla',
                        command: () => { console.log("profile clicked"); }
                    }
                ]
            },
            {
                label: 'Ayuda',
                command: () => { console.log("profile clicked"); },
                icon: 'pi pi-fw pi-question-circle'
            }
        ];
    };
    searchChanges() {
        const that = this;
        this.catalogService.currentCatalog$.subscribe((catalog) => {
            console.log(catalog);
            this.showIt = false;
            this.catalog = catalog;
            if (this.catalog != null && this.catalog) {
                that.setMenuItems();
                that.showIt = true;
            }

        });
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
        this.menuOpened = this.layoutService.state.staticMenuDesktopInactive;
    }

    onProfileButtonClick() {
        this.layoutService.showProfileSidebar();
    }
    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }

}